import TextComponent from "Component/Render/Text";
import TransformComponent from "Component/Transform";
import { EventQuestsPopupLayout } from "Layouts/Quests/EventQuestsPopupLayout";
import { IGameState } from "State/Game/IGameState";
import { GLayout } from "Utility/layout/LayoutHelper";
import { MathHelper } from "Utility/MathHelper";
import { getCurrentTractorPosition } from "../SeasonPass/TractorHelper";
import Renderable from "Component/Renderable";
import GameObject, { GameObjectEvent } from "GameObject/GameObject";
import SpriteComponent from "Component/Render/Sprite";
import SeasonPassRankScroll from "Prototype/UI/SeasonPass/SeasonPassRankScroll";
import Element from "Prototype/UI/Element";
import { SeasonPassRankItem } from "Prototype/UI/SeasonPass/SeasonPassRankItem";
import SeasonPassTimer from "System/Timer/Timers/SeasonPassTimer";
import { SeasonPassActions } from "State/SeasonPass/SeasonPassActions";
import { EventQuestPopupLayout } from "Constants/Events/CurrentEvent";
import { SeasonPassRankProgressItem } from "Prototype/UI/SeasonPass/SeasonPassRankProgressItem";
import { SeasonPassRankMilestoneItem } from "Prototype/UI/SeasonPass/SeasonPassRankMilestoneItem";
import { finishedSeasonPass, getLastSeenSeasonPassProgressDifference, getSeasonPassLastSeenProgress, hasPremiumReminder, hasUnclaimedSeasonPassReward } from "State/Player/PlayerSeasonPassHelper";
import Game from "Game";
import { AnimationClipEvent } from "System/Animation/AnimationClip";
import { StartAnimation, StartAnimationClip } from "System/Animation/AnimationHelper";
import { Alpha, ScrollToPosition } from "System/Animation/Clip";
import { SeasonPassInfoPopup } from "./SeasonPassPopup/SeasonPassInfoPopup";
import { hasFlag } from "State/Player/PlayerFlagHelper";
import { SEASON_PASS_INTRO_INFO, SEASON_PASS_NEW_SEASON_FTUX } from "Constants/SeasonPass";
import { SeasonPassPurchasePopup } from "./SeasonPassPopup/SeasonPassPurchasePopup";
import Interactable from "Component/Interactable";
import { ResponseType, ResponseStatus } from "State/Game/ContextType";
import { GameActions } from "State/Game/GameActions";
import { IAPHelper } from "Utility/Helpers/IAP/IAPHelper";
import { ProductId } from "Utility/Product";
import { SeasonPassPurchaseReminderPopup } from "./SeasonPassPopup/SeasonPassPurchaseReminderPopup";
import UIScrollComponent from "Component/UI/Scroll";
import QuestsMenuHandler from "./QuestsMenuHandler";
import { PlayerActions } from "State/Player/PlayerActions";
import { getSeasonPassEndDate } from "Utility/SeasonPassHelper";
import { SeasonPassPurchaseCompletePopup } from "./SeasonPassPopup/SeasonPassPurchaseCompletePopup";
import { SeasonPassRank } from "Types/State/Player/SeasonPass";
import DateHelper from "Utility/DateHelper";
import { PopupID } from "State/UI/PopupID";
import { UIActions } from "State/UI/UIActions";

export const SEASON_PASS_SCROLL_BOX_WIDTH = 650;
export const SEASON_PASS_SCROLL_BOX_HEIGHT = 350;
export const SEASON_PASS_SCROLL_ITEM_WIDTH = 160;
export const SEASON_PASS_TAB_PROGRESS_WIDTH = 120;
export const SEASON_PASS_HEADER_PROGRESS_WIDTH = 200;

export interface ISeasonPassRankLayout {
    seasonPassScrollView: Element;
    seasonPassRankItems: SeasonPassRankItem[];
    seasonPassMilestones: SeasonPassRankMilestoneItem[];
    seasonPassProgressItem: SeasonPassRankProgressItem;
    seasonPassPurchasePopup?: SeasonPassPurchasePopup;
    seasonPassPurchaseReminderPopup?: SeasonPassPurchaseReminderPopup;
    seasonPassInfoPopup?: SeasonPassInfoPopup;
}

export function handleQuestTabs(layout: GLayout<EventQuestsPopupLayout>, seasonPassLayout: ISeasonPassRankLayout, questsMenuHandler: QuestsMenuHandler) {
    layout.subLayout.missionsHeader.getComponent(Renderable).visible = false;
    layout.subLayout.tabContainerFront.getComponent(Renderable).visible = true;
    layout.subLayout.tabContainerBack.getComponent(Renderable).visible = true;

    layout.subLayout.tabMissions.on(GameObjectEvent.POINTER_DOWN, () => {
        if (!questsMenuHandler.blockClose)
            switchToMissionTab(layout);
    });
}

export function switchToMissionTab(layout: GLayout<EventQuestsPopupLayout>) {
    layout.subLayout.mission_board.getComponent(Renderable).visible = true;
    layout.subLayout.season_pass_board.getComponent(Renderable).visible = false;
    layout.subLayout.tabContainerFront.addChild(layout.subLayout.tabMissions);
    layout.subLayout.tabMissions.getComponent(SpriteComponent).texture = 'title_tab_front';
}

export function switchToSeasonPassTab(layout: GLayout<EventQuestsPopupLayout>, seasonPassLayout: ISeasonPassRankLayout, openReminder = false) {
    layout.subLayout.mission_board.getComponent(Renderable).visible = false;
    layout.subLayout.season_pass_board.getComponent(Renderable).visible = true;
    layout.subLayout.tabContainerBack.addChild(layout.subLayout.tabMissions);
    layout.subLayout.tabMissions.getComponent(SpriteComponent).texture = 'title_tab_back';

    const state = Game.store.getState();

    const progressDifference = getLastSeenSeasonPassProgressDifference(state.playerState);

    updateSeasonPassLayout(layout as GLayout<EventQuestPopupLayout>, seasonPassLayout, progressDifference, () => {
        if (openReminder || hasPremiumReminder(state)) {
            showPurchaseReminderPopup(state, layout, seasonPassLayout);
        }
    });

    if (!hasFlag(state.playerState, SEASON_PASS_INTRO_INFO)) {
        PlayerActions.setFlag({ id: SEASON_PASS_NEW_SEASON_FTUX, expiryDate: getSeasonPassEndDate() });
        showInfoPopup(layout, seasonPassLayout, () => {
            seasonPassLayout.seasonPassRankItems[0].animationRewardUnlocked(300);
        });
    }
}

export function isSeasonPassTabActive(): boolean {
    return false;
    const seasonPassLayout = GameObject.findFirstByName(
        'season_pass_board'
    );
    return seasonPassLayout.getComponent(Renderable).visible;
}

export function createSeasonPassLayout(
    state: IGameState,
    layout: GLayout<EventQuestsPopupLayout>,
    questsMenuHandler: QuestsMenuHandler,
): ISeasonPassRankLayout {
    const timer = new SeasonPassTimer();
    timer.onUpdate = (state: IGameState) => {
        const timeRemaining = DateHelper.getDateFromValue(state.playerState.seasonPass.endDate).getTime() - DateHelper.now.getTime();
        if (timeRemaining <= 0) {
            if (seasonPassRankLayout.seasonPassPurchasePopup) {
                seasonPassRankLayout.seasonPassPurchasePopup.hidePurchaseError();
                seasonPassRankLayout.seasonPassPurchasePopup.destroy();
                setTimeout(() => {
                    UIActions.hidePopup(PopupID.QUEST_MENU);
                }, 850);
            } else if (seasonPassRankLayout.seasonPassPurchaseReminderPopup) {
                seasonPassRankLayout.seasonPassPurchaseReminderPopup.hidePurchaseError();
                seasonPassRankLayout.seasonPassPurchaseReminderPopup.destroy();
                setTimeout(() => {
                    UIActions.hidePopup(PopupID.QUEST_MENU);
                }, 850);
            } else {
                UIActions.hidePopup(PopupID.QUEST_MENU);
            }
            Game.store.dispatch(SeasonPassActions.resetSeasonPass());
        }
        if (layout.subLayout.SeasonPassHeader.timeText?.getComponent(TextComponent)) {
            layout.subLayout.SeasonPassHeader.timeText.getComponent(TextComponent).text = timer.getFormattedCountdown(state);
        }
    };
    timer.onUpdate(state);

    layout.subLayout.SeasonPassHeader.SPProgressBar.on(GameObjectEvent.POINTER_DOWN, () => {
        showTooltip(layout.subLayout.SeasonPassHeader.ProgressTooltip);
    });

    layout.subLayout.SeasonPassInfoButton.on(GameObjectEvent.SELECTED, () => {
        showInfoPopup(layout, seasonPassRankLayout);
    });

    handlePremiumPurchase(layout);

    layout.subLayout.PremiumFieldIcon.on(GameObjectEvent.POINTER_DOWN, () => {
        if (!state.playerState.seasonPass.boughtPremiumPass) {
            showPurchasePopup(layout, seasonPassRankLayout);
        }
    });

    layout.subLayout.SeasonPassHeader.SPActivatePremiumButton.on(GameObjectEvent.POINTER_DOWN, () => {
        showPurchasePopup(layout, seasonPassRankLayout);
    });

    const seasonPassRankLayout = createSeasonPassRanksViewPort(state, layout, questsMenuHandler);

    updateSeasonPassLayout(layout, seasonPassRankLayout);

    return seasonPassRankLayout;
}

function showInfoPopup(layout: GLayout<EventQuestsPopupLayout>, seasonPassLayout: ISeasonPassRankLayout, onClose?: () => void) {
    if (seasonPassLayout.seasonPassInfoPopup) return;

    seasonPassLayout.seasonPassInfoPopup = GameObject.Instantiate(SeasonPassInfoPopup);
    layout.root.addChild(seasonPassLayout.seasonPassInfoPopup);

    seasonPassLayout.seasonPassInfoPopup.on(GameObjectEvent.DESTROYED, () => {
        seasonPassLayout.seasonPassInfoPopup = null;
        if (onClose) {
            onClose();
        }
    });
}

function showPurchaseCompletePopup(layout: GLayout<EventQuestsPopupLayout>, onComplete: () => void) {
    const popup = GameObject.Instantiate(SeasonPassPurchaseCompletePopup);
    layout.root.addChild(popup);
    popup.on(GameObjectEvent.DESTROYED, onComplete);
}

function showPurchaseReminderPopup(state: IGameState, layout: GLayout<EventQuestsPopupLayout>, seasonPassLayout: ISeasonPassRankLayout) {
    if (seasonPassLayout.seasonPassPurchaseReminderPopup) return;

    seasonPassLayout.seasonPassPurchaseReminderPopup = GameObject.Instantiate(SeasonPassPurchaseReminderPopup, { state });
    layout.root.addChild(seasonPassLayout.seasonPassPurchaseReminderPopup);

    seasonPassLayout.seasonPassPurchaseReminderPopup.on(GameObjectEvent.DESTROYED, () => {
        seasonPassLayout.seasonPassPurchaseReminderPopup = null;
    });

    handlePurchaseResult(seasonPassLayout.seasonPassPurchaseReminderPopup, layout, seasonPassLayout);
}

export function showPurchasePopup(layout: GLayout<EventQuestsPopupLayout>, seasonPassLayout: ISeasonPassRankLayout) {
    if (seasonPassLayout.seasonPassPurchasePopup) return;

    seasonPassLayout.seasonPassPurchasePopup = GameObject.Instantiate(SeasonPassPurchasePopup);
    layout.root.addChild(seasonPassLayout.seasonPassPurchasePopup);

    seasonPassLayout.seasonPassPurchasePopup.on(GameObjectEvent.DESTROYED, () => {
        seasonPassLayout.seasonPassPurchasePopup = null;
    });

    handlePurchaseResult(seasonPassLayout.seasonPassPurchasePopup, layout, seasonPassLayout);
}

async function handlePurchaseResult(purchasePopup: SeasonPassPurchasePopup | SeasonPassPurchaseReminderPopup, layout: GLayout<EventQuestsPopupLayout>, seasonPassLayout: ISeasonPassRankLayout) {
    const product = IAPHelper.CACHED_IAP_REWARDS_MAP()[ProductId.PREMIUM_SEASON_PASS];
    await Promise.race([
        Game.store.waitFor(GameActions.restoreContext).then((result) => {
            if (result.payload.type !== ResponseType.PURCHASE_PRODUCT || result.payload.data.product !== product)
                return;

            if (result.payload.status === ResponseStatus.FAIL) {
                purchasePopup.showPurchaseError(result.payload.data.errorMsg);
                handlePurchaseResult(purchasePopup, layout, seasonPassLayout);
                return;
            }

            if (result.payload.status === ResponseStatus.SUCCESS) {
                purchasePopup.destroy();

                handlePremiumPurchase(layout);

                const state = Game.store.getState();

                showPurchaseCompletePopup(layout, () => {
                    const currentScrollPosition = seasonPassLayout.seasonPassScrollView.getComponent(UIScrollComponent).UIComponent.getScrollPosition();
                    StartAnimationClip(new ScrollToPosition(seasonPassLayout.seasonPassScrollView, {
                        duration: 500,
                        startPosition: currentScrollPosition.x,
                        endPosition: 0,
                        onComplete: () => {
                            seasonPassLayout.seasonPassRankItems.forEach((entry, index) => {
                                entry.unlockPremiumReward();
                                if (index < state.playerState.seasonPass.currentRank) {
                                    entry.claimPremiumReward((index * 1300) + 1000, () => {
                                        if (index === state.playerState.seasonPass.currentRank - 1) {
                                            claimRewards(state);
                                        } else {
                                            const currentScrollPosition = seasonPassLayout.seasonPassScrollView.getComponent(UIScrollComponent).UIComponent.getScrollPosition();
                                            StartAnimationClip(new ScrollToPosition(seasonPassLayout.seasonPassScrollView, {
                                                duration: 300,
                                                startPosition: currentScrollPosition.x,
                                                endPosition: currentScrollPosition.x - SEASON_PASS_SCROLL_ITEM_WIDTH,
                                            }));
                                        }
                                    });
                                }
                            });
                        }
                    }));
                });
            }
        }),
        new Promise<void>(resolve => {
            purchasePopup.on(GameObjectEvent.DESTROYED, resolve);
        }),
    ]);
}

function handlePremiumPurchase(layout: GLayout<EventQuestsPopupLayout>) {
    const state = Game.store.getState();
    layout.subLayout.SeasonPassHeader.SPActivatePremiumButton.getComponent(Renderable).visible = !state.playerState.seasonPass.boughtPremiumPass;
    if (state.playerState.seasonPass.boughtPremiumPass) {
        layout.subLayout.PremiumFieldIcon.getComponent(Interactable).buttonMode = false;
        layout.subLayout.PremiumFieldIcon.getComponent(Interactable).enabled = false;
    }
}

export function updateSeasonPassLayout(
    layout: GLayout<EventQuestsPopupLayout>,
    seasonPassLayout: ISeasonPassRankLayout,
    progressDifference = 0,
    reminderPopupCallback?: () => void,
) {
    return;
    const state = Game.store.getState();
    const spRankProgress = getCurrentTractorPosition(state.playerState).progress;
    const spRankTarget = state.playerState.seasonPass?.ranks[getCurrentTractorPosition(state.playerState).rank]?.neededProgress;
    const spRank = getCurrentTractorPosition(state.playerState).rank + 1;
    const spRankProgressLastSeen = getCurrentTractorPosition(state.playerState, true).progress;
    const spRankTargetLastSeen = state.playerState.seasonPass?.ranks[getCurrentTractorPosition(state.playerState, true).rank]?.neededProgress;
    const spRankLastSeen = getCurrentTractorPosition(state.playerState, true).rank + 1;

    if (finishedSeasonPass(state.playerState)) {
        layout.subLayout.TabSPProgressBar.getComponent(Renderable).visible = false;
        layout.subLayout.SeasonPassHeader.SPProgressBar.getComponent(Renderable).visible = false;
        layout.subLayout.SeasonPassHeader.SPCompleteContainer.getComponent(Renderable).visible = true;
        layout.subLayout.SeasonPassTabTitle.getComponent(TransformComponent).x = 0;
    } else {
        layout.subLayout.TabSPMilestoneText.getComponent(TextComponent).text = `${spRank}`;
        layout.subLayout.TabSPProgressText.getComponent(TextComponent).text = `${spRankProgress} / ${spRankTarget}`;
        layout.subLayout.SeasonPassHeader.SPMilestoneText.getComponent(TextComponent).text = `${spRankLastSeen}`;
        layout.subLayout.SeasonPassHeader.SPProgressText.getComponent(TextComponent).text = `${spRankProgressLastSeen} / ${spRankTargetLastSeen}`;

        const fill = layout.subLayout.TabSPProgressBarFill;
        const headerFill = layout.subLayout.SeasonPassHeader.SPProgressBarFill;

        if (spRankProgress !== 0) {
            const percProgress = MathHelper.normalize(spRankProgress, 0, spRankTarget);
            fill.getComponent(TransformComponent).width = Math.min(
                MathHelper.lerp(0, SEASON_PASS_TAB_PROGRESS_WIDTH, percProgress),
                SEASON_PASS_TAB_PROGRESS_WIDTH
            );
        } else {
            fill.getComponent(TransformComponent).width = 0;
        }
        if (spRankProgressLastSeen !== 0) {
            const percProgressLastSeen = MathHelper.normalize(spRankProgressLastSeen, 0, spRankTargetLastSeen);
            headerFill.getComponent(TransformComponent).width = Math.min(
                MathHelper.lerp(0, SEASON_PASS_HEADER_PROGRESS_WIDTH, percProgressLastSeen),
                SEASON_PASS_HEADER_PROGRESS_WIDTH
            );
        } else {
            headerFill.getComponent(TransformComponent).width = 0;
        }
    }

    const lastSeenTractorPosition = getCurrentTractorPosition(state.playerState, true);
    if (progressDifference > 0 && lastSeenTractorPosition.rank < state.playerState.seasonPass.ranks.length) {
        const currentRank = lastSeenTractorPosition.rank;
        const oldProgress = lastSeenTractorPosition.progress;
        SeasonPassProgressUpdateAnimation(state.playerState.seasonPass.ranks, currentRank, oldProgress, progressDifference, 0, 1500, {
            root: layout.root,
            progressFill: layout.subLayout.SeasonPassHeader.SPProgressBarFill,
            milestoneText: layout.subLayout.SeasonPassHeader.SPMilestoneText,
            progressText: layout.subLayout.SeasonPassHeader.SPProgressText,
            progressMaxWidth: SEASON_PASS_HEADER_PROGRESS_WIDTH
        });
        seasonPassLayout.seasonPassProgressItem.animateRankProgress(state.playerState, progressDifference, (rank) => {
            seasonPassLayout.seasonPassMilestones[rank - 1].animateMilestone();
            seasonPassLayout.seasonPassRankItems[rank - 1].animationRewardUnlocked();
            const currentScrollPosition = seasonPassLayout.seasonPassScrollView.getComponent(UIScrollComponent).UIComponent.getScrollPosition();
            StartAnimationClip(new ScrollToPosition(seasonPassLayout.seasonPassScrollView, {
                duration: 300,
                startPosition: currentScrollPosition.x,
                endPosition: currentScrollPosition.x - SEASON_PASS_SCROLL_ITEM_WIDTH,
            }));
        }, () => {
            if (reminderPopupCallback) reminderPopupCallback();
            SeasonPassActions.setSeasonPassLastSeenProgress(getCurrentTractorPosition(state.playerState));
            const newState = Game.store.getState();
            seasonPassLayout.seasonPassRankItems.forEach(entry => {
                entry.updateState(newState);
            });
        });
    } else {
        seasonPassLayout.seasonPassProgressItem.updateLayout(state);

        seasonPassLayout.seasonPassRankItems.forEach(entry => {
            entry.updateLayout(state);
        });

        seasonPassLayout.seasonPassMilestones.forEach(entry => {
            entry.updateLayout(state);
        });

        if (reminderPopupCallback) reminderPopupCallback();
    }

    claimRewards(state);
}

export function claimRewards(state: IGameState) {
    if (hasUnclaimedSeasonPassReward(state)) {
        state.playerState.seasonPass.ranks.forEach((rank, index) => {
            if (rank.free.state === 'claimable') {
                SeasonPassActions.claimRankReward(index + 1, 'free');
            }
            if (rank.premium.state === 'claimable') {
                SeasonPassActions.claimRankReward(index + 1, 'premium');
            }
        });
    }
}

export function createSeasonPassRanksViewPort(
    state: IGameState,
    layout: GLayout<EventQuestsPopupLayout>,
    questsMenuHandler: QuestsMenuHandler,
): ISeasonPassRankLayout {
    const SCROLL_AREA: string = 'season_pass_scroll_area';

    let seasonPassRankItems: SeasonPassRankItem[] = [];
    let seasonPassProgressItem: SeasonPassRankProgressItem = null;
    let seasonPassMilestones: SeasonPassRankMilestoneItem[] = [];

    const seasonPassScrollView: Element = GameObject.Instantiate(SeasonPassRankScroll, {
        name: SCROLL_AREA,
        layout: {
            anchors: [0, 0, 0, 0],
            pivot: [0, 0],
            offsets: [0, 0, 0, 0],
            constrains: {
                heightMin: SEASON_PASS_SCROLL_BOX_HEIGHT,
                heightMax: SEASON_PASS_SCROLL_BOX_HEIGHT,
                widthMin: SEASON_PASS_SCROLL_BOX_WIDTH,
                widthMax: SEASON_PASS_SCROLL_BOX_WIDTH,
            },
        },
        scrollWidth: SEASON_PASS_SCROLL_ITEM_WIDTH * state.playerState.seasonPass.ranks.length,
        scrollHeight: SEASON_PASS_SCROLL_BOX_HEIGHT,
    });

    layout.subLayout.SeasonPassContent.addChild(seasonPassScrollView);

    seasonPassProgressItem = GameObject.Instantiate(SeasonPassRankProgressItem, { state: state });
    seasonPassScrollView.addChild(seasonPassProgressItem);

    state.playerState.seasonPass.ranks.forEach((rank, index) => {
        const item = GameObject.Instantiate(SeasonPassRankItem, { state: state, key: index, itemWidth: SEASON_PASS_SCROLL_ITEM_WIDTH, questsMenuHandler });
        const milestoneitem = GameObject.Instantiate(SeasonPassRankMilestoneItem, { state: state, key: index, itemWidth: SEASON_PASS_SCROLL_ITEM_WIDTH });
        seasonPassRankItems.push(item);
        seasonPassMilestones.push(milestoneitem);
        seasonPassScrollView.addChild(milestoneitem);
        seasonPassScrollView.addChild(item);
    });

    seasonPassScrollView.container.resize(0, 0);
    seasonPassScrollView.getComponent(UIScrollComponent).UIComponent.scrollToPosition(-(getSeasonPassLastSeenProgress(state.playerState).rank - 1) * SEASON_PASS_SCROLL_ITEM_WIDTH, 0);
    seasonPassScrollView.getComponent(UIScrollComponent).UIComponent.setScrollEndListener((x, y, isEnd) => {
        layout.subLayout.SeasonPassStartScroll.getComponent(Renderable).visible = x < 0;
        layout.subLayout.SeasonPassEndScroll.getComponent(Renderable).visible = !isEnd;
    });

    return {
        seasonPassScrollView,
        seasonPassRankItems,
        seasonPassMilestones,
        seasonPassProgressItem
    }
}

export function SeasonPassProgressUpdateAnimation(ranks: SeasonPassRank[], currentRank: number, currentProgress: number, progress: number, delay: number, duration: number, layout: {
    root: GameObject,
    progressFill: GameObject,
    milestoneText: GameObject,
    progressText: GameObject,
    progressMaxWidth: number,
}, onAniamtionComplete?: () => void): void {
    let oldProgress = currentProgress;
    let remainingProgress = oldProgress + progress;
    let rank = currentRank;

    let firstAnimationStep = true;

    function getTarget(rank: number): number {
        return ranks[rank]?.neededProgress || 0;
    }

    function createAnimationStep(
        rank: number,
        endProgress: number,
        onComplete: () => void
    ) {
        const target = getTarget(rank);
        const percProgressEnd = MathHelper.normalize(endProgress, 0, target);
        const initialDelay = firstAnimationStep ? delay : 0;
        firstAnimationStep = false;

        StartAnimation(layout.root, 'SeasonPassProgress', {
            progressFill: layout.progressFill,
            progressMilestone: layout.milestoneText,
            progressText: layout.progressText,
            progress: percProgressEnd,
            progressMaxWidth: layout.progressMaxWidth,
            progressTextValue: `${endProgress} / ${target}`,
            milestoneTextValue: `${rank + 1}`,
            initialDelay,
            duration,
            onComplete,
        });
    }

    function resetToZeroAnimation(onComplete: () => void) {
        StartAnimation(layout.root, 'SeasonPassProgress', {
            progressFill: layout.progressFill,
            progressMilestone: layout.milestoneText,
            progressText: layout.progressText,
            progress: 0,
            progressMaxWidth: layout.progressMaxWidth,
            progressTextValue: `0 / ${getTarget(rank)}`,
            milestoneTextValue: `${rank + 1}`,
            reset: true,
            duration,
            onComplete,
        });
    }

    function processNextAnimation() {
        const target = getTarget(rank);

        if (remainingProgress >= target) {
            // Full progress bar animation for this rank
            createAnimationStep(rank, target, () => {
                resetToZeroAnimation(() => {
                    remainingProgress -= target;
                    oldProgress = 0; // Reset progress for the next rank
                    rank++; // Move to the next rank
                    processNextAnimation(); // Continue to the next animation
                });
            });
        } else {
            // Partial progress bar animation for the remaining points
            createAnimationStep(rank, remainingProgress, () => {
                if (onAniamtionComplete) onAniamtionComplete();
            });
        }
    }

    processNextAnimation();
}

function showTooltip(gameObject: GameObject): void {
    fadeIn(gameObject);

    Game.ticker.setTimeout(() => {
        fadeOut(gameObject);
    }, 2000);
}

function fadeIn(gameObject: GameObject, endAlpha: number = 1) {
    StartAnimationClip(
        new Alpha(gameObject, {
            startAlpha: 0,
            endAlpha,
            duration: 450,
        })
    );
}

function fadeOut(gameObject: GameObject, startAlpha: number = 1) {
    StartAnimationClip(
        new Alpha(gameObject, {
            startAlpha,
            endAlpha: 0,
            duration: 450,
        }).once(AnimationClipEvent.DESTROY, () => {
            gameObject.getComponent(Renderable).visible = false;
        })
    );
}